import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ActivityForm } from '@/components/crm/ActivityForm';

export default function NewActivity() {
  const navigate = useNavigate();
  const { customerId } = useParams();
  const [initialCustomerId] = useState(customerId ? parseInt(customerId) : undefined);

  const handleSuccess = () => {
    // If coming from customer page, go back to that customer
    if (customerId) {
      navigate(`/customer/${customerId}`);
    } else {
      // Otherwise go to activities list
      navigate('/crm/activities');
    }
  };

  return (
    <div className="container py-8 max-w-3xl mx-auto">
      <div className="flex flex-col space-y-8">
        {/* Header */}
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
          <h1 className="text-2xl font-bold tracking-tight">New Customer Activity</h1>
        </div>
        
        {/* Form Card */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle>Activity Details</CardTitle>
            <CardDescription>
              Record a new customer interaction or schedule an upcoming one
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ActivityForm 
              onSuccess={handleSuccess}
              initialCustomerId={initialCustomerId}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
} 